import {
  createEffect,
  createEvent,
  Effect,
  sample,
  type EventCallable,
} from 'effector'
import { dataLayerPush, fbq } from './helpers/tracking'

export const init: EventCallable<void> = createEvent()

const seoTrackingTimeoutFx: Effect<void, void> = createEffect<void, void>(
  () => {
    const durations = [3, 5, 10, 20, 30] // minutes

    durations.forEach((minutes) => {
      const eventName = `${minutes}minDuration`
      setTimeout(
        () => {
          fbq({ action: 'trackCustom', eventName })
          dataLayerPush(eventName)
        },
        minutes * 60 * 1000
      )
    })
  }
)

sample({
  clock: init,
  target: seoTrackingTimeoutFx,
})
